import styled from 'styled-components';

export const QuestionsToAskModalComponent = styled.div`
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    height: 100vh;
    padding: 102px 0;
    width: 99vw;
    background: rgba(67, 89, 112, 0.87);
`;
export const CloseIcon = styled.div`
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
`;
export const QuestionsToAskModalWrapper = styled('div')`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    padding: 32px;
    width: 600px;
    min-height: 350px;
    height: max-content;
    border-radius: 8px;
    outline: none;
    border: 1px solid #849cb1;
    background-color: white;
    overflow-y: auto;
`;

export const TitleSection = styled('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
`;
export const Title = styled('div')`
    font-weight: 700;
    font-size: 18px;
    line-height: 32px;
    color: #40596f;
`;

export const Description = styled('ul')`
    color: #435970;
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    padding-left: 18px;
    list-style: disc;
    &.desc {
        padding-left: 0;
        line-height: 24px;
    }
`;
